export enum STAGES {
  INITIAL = 'initial',
  RESULTS = 'results',
  WAITING = 'waiting',
  QUESTION = 'question',
}

export const DEFAULT_QUESTION_COLOR = '#ffd63b';

export const SWITCH_ANIMATION_DURATION_MS = 500;

export const SWITCH_QUESTION_UTC_HOUR = 21;

export const USER_ANSWERED_QUESTION = 'User already answered the question';

export const DAILY_COMPETITION_SLUG = 'daily-question';
